import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#FFa876",
      main: "#FF844B",
      dark: "#FF6D00",
    },
    secondary: {
      main: "#808390",
    },
    error: {
      main: "#FF4C51",
    },
    warning: {
      main: "#FF9F43",
    },
    success: {
      main: "#28C76F",
    },
    info: {
      main: "#00BAD1",
    },
    background: {
      default: "#F8F7FA",
      paper: "#FFFFFF",
    },
    text: {
      primary: "rgba(47, 43, 61, 0.9)",
      secondary: "rgba(47, 43, 61, 0.7)",
      disabled: "rgba(47, 43, 61, 0.4)",
    },
    divider: "rgba(47, 43, 61, 0.12)",
  },
  spacing: 8,
  typography: {
    fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 13.125,
    h5: {
      fontWeight: 500,
      fontSize: "1.375rem",
      letterSpacing: 0.5,
    },
    h6: {
      fontSize: "0.9375rem",
      fontWeight: 500,
      lineHeight: 1.46667,
    },
    body1: {
      fontSize: "0.9375rem",
      lineHeight: 1.46667,
    },
    body2: {
      fontSize: "0.8125rem",
      lineHeight: 1.53846,
    },
    caption: {
      fontSize: "0.8125rem",
      lineHeight: 1.38462,
      letterSpacing: "0.4px",
    },
    button: {
      fontSize: "0.9375rem",
      lineHeight: 1.46667,
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 6,
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

export const customTheme = {
  ...theme,
  overrides: {
    MuiDrawer: {
      paper: {
        border: "none",
        backgroundColor: "#ffffff",
      },
    },
    MuiButton: {
      label: {
        textTransform: "none",
      },
      contained: {
        boxShadow: "none",
        "&:active": {
          boxShadow: "none",
        },
      },
    },
    MuiMenu: {
      paper: {
        border: "1px solid rgba(47, 43, 61, 0.12)",
        minWidth: 140,
        borderRadius: 6,
        boxShadow: "0px 4px 18px rgba(47, 43, 61, 0.16)",
      },
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiMenuItem: {
      root: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        fontSize: "0.9375rem",
        lineHeight: 1.46667,
        color: "rgba(47, 43, 61, 0.9)",
        "&.Mui-selected": {
          color: "#FF844B",
          fontWeight: 800,
          backgroundColor: "unset",
          "& .MuiListItemText-primary": {
            fontWeight: 800,
          },
        },
        "&:hover, &.Mui-selected:hover": {
          color: "#FF844B",
          backgroundColor: "rgba(255, 132, 75, 0.08)",
        },
      },
    },
    MuiListItemText: {
      root: {
        marginTop: 0,
        marginBottom: 0,
      },
      primary: {
        fontFamily: '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: "0.9375rem",
        fontWeight: "normal",
        fontStyle: "normal",
        lineHeight: 1.46667,
        color: "#FF844B",
      },
    },
    MuiListItemSecondaryAction: {
      root: {
        right: 0,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: "rgba(47, 43, 61, 0.12)",
      },
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiListItemIcon: {
      root: {
        color: "inherit",
        marginRight: 0,
        "& svg": {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
    MuiPopover: {
      paper: {
        borderRadius: 6,
      },
    },
  },
};
